import React, { useState } from 'react';
import './Login.css';

const API_URL = process.env.REACT_APP_API_URL;

const Login = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const response = await fetch(`${API_URL}/api/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (response.ok) {
        // Sauvegarde l'objet utilisateur complet
        localStorage.setItem('driverUser', JSON.stringify(data.user));
        onLogin();
      } else {
        setError(data.error || 'Une erreur est survenue.');
      }
    } catch (err) {
      setError('Erreur réseau. Veuillez réessayer.');
    }
  };

  return (
    <div className="login-container">
        <form onSubmit={handleLogin} className="login-form">
          <h2>Connexion Chauffeur</h2>
          <input
            type="email"
            placeholder="Adresse e-mail"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Mot de passe"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          {error && <p className="error-message">{error}</p>}
          <button type="submit">Se connecter</button>
        </form>
    </div>
  );
};

export default Login;
